// header 
import { Link, useNavigate } from "react-router-dom";
import { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import StateContext from '../stateContext';
import browse from './imgs/browse.svg';
import track from './imgs/track.svg';
import settings from './imgs/settings.svg';
import menu from './imgs/menu.svg';

function Header() {

  const curPath = window.location.pathname;
  const navigate = useNavigate();
  
  const { setUserInfo, userInfo, createNotification, validUserCreds, globalHeader, setPopup } = useContext(StateContext);
  
  const [ menuVis, setMenuVis ] = useState(false);

  async function signOut() {

    axios.patch(
      '/api/account/logout',
    {
      "email": userInfo.email,
      "jwt": userInfo.jwt
    }
    ).then((response) => {

      if (response.status == 200 && response.data.success == true && response.data.results > 0) {
        createNotification({
          "status": "success",
          "msg": "Logout complete",
        })
      } else {
        // prompt error 
        createNotification({
          "status": "error",
          "msg": "Error logging out",
        })
      }
      
      // erase user info
      setUserInfo({});

      // clear session data
      localStorage.clear();
      sessionStorage.clear();

      // move user to login screen
      if (!curPath.startsWith("/home")) {
        navigate('/login');
      }

    })
  }

  async function manageSubscription() {

    if (["active", "trialing", "past_due", "unpaid", "canceled", "incomplete_expired", "past_due"].includes(userInfo.subscription_status)) { 
      // set loading
      setPopup({type: "loading", "msg": "Loading subscription management!"});

      // generate subscription management session
      axios.defaults.xsrfCookieName = 'csrftoken';
      axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
      axios.defaults.withCredentials = true;

      axios.post("/api/subscription/manage",
        {
          email: userInfo.email,
          jwt: userInfo.jwt,
          return_url: window.location.href
        }
      ).then((response) => {
        if (response.status == 200 && response.data.results > 0 && response.data.success == true && response.data.results > 0) {
          // clear popup
          setPopup(undefined)

          // route user to link
          window.location.href = response.data.result;
        } else {
          createNotification({
            "status": "error",
            "msg": "Error redirecting to subscription management",
          })
        }
      })
    } else {
      // prompt user to subscribe
      setPopup({type: "subscribe", "msg": "Become a WorkGuild Premium Member to Generate Resumes!"});
    }
  }


  var headerTitle = "";
  if ( curPath != undefined ){
    if ( curPath.toLowerCase().startsWith( "/profile/userdetails")) { headerTitle = "User Information" }
    else if( curPath.toLowerCase().startsWith( "/profile/workexperience")) { headerTitle = "Work Experience" }
    else if( curPath.toLowerCase().startsWith( "/profile/skills")) { headerTitle = "Skills" }
    else if( curPath.toLowerCase().startsWith( "/profile/education")) { headerTitle = "Education" }
    else if( curPath.toLowerCase().startsWith( "/profile/topicexcludes")) { headerTitle = "Topic Excludes" }
    else if( curPath.toLowerCase().startsWith( "/profile/desiredroles")) { headerTitle = "Desired Roles" }
    else if( curPath.toLowerCase().startsWith( "/subscription")) { headerTitle = "Welcome to the ranks!" }

    else if( curPath.toLowerCase().startsWith( "/applications/applied")) { headerTitle = "Applied Application" }
    else if( curPath.toLowerCase().startsWith( "/applications/unapplied")) { headerTitle = "Unapplied Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/not_interested")) { headerTitle = "Uninterested Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/too_far")) { headerTitle = "Out of Range Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/position_accepted")) { headerTitle = "Accepted Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/interviewing")) { headerTitle = "Interviewing Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/not_selected")) { headerTitle = "Not Selected Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/does_not_exist")) { headerTitle = "Non-existent Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications/all")) { headerTitle = "My Applications" }
    else if( curPath.toLowerCase().startsWith( "/applications")) { headerTitle = "My Applications" }
    else if( curPath.toLowerCase().startsWith( "/resume/selectdefault")) { headerTitle = "Default Resume Format" }

    else if( curPath.toLowerCase().startsWith( "/trackapplication")) { headerTitle = "Track New Application" }
    else if( curPath.toLowerCase().startsWith( "/trackapplication")) { headerTitle = "Work Guild" }
    else if( curPath.toLowerCase().startsWith( "/suggested")) { headerTitle = "Suggested Jobs" }
    else if( globalHeader == undefined && curPath.toLowerCase().startsWith( "/company")) { headerTitle = "Loading Company Overview" }

    else if (globalHeader != undefined) {
      headerTitle = globalHeader;
    }
  }

  return (
    <>
      <header>
        <title>{headerTitle != undefined ? `WorkGuild.io | ${typeof(headerTitle) == "object" ? headerTitle.anchor : headerTitle}` : 'WorkGuild.io'}</title>
        { curPath == "/" || curPath.startsWith("/home") || curPath.startsWith("/about") || curPath == "" || /^\/\d\/\d{1,}$/.test(curPath) ?  
          <Link to="/" className="logo" style={{fontSize: "32px", fontWeight: "bold"}}>Work Guild<span style={{fontSize: "20px", color: "black"}}>.io</span></Link>
        : 
          <h1 style={{width: "100%"}}>{typeof(headerTitle) == "object" ? 
            <>
              <a href={headerTitle.href} target={headerTitle.target ? headerTitle.target : undefined}
                style={{display: "flex", gap: "5px", alignItems: "center"}}
              >
                {headerTitle.anchor} 
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a> 
            </>
          : headerTitle}</h1>
        }

        <nav className="headerNav">
          <Link to="/home" className="desktopMenuButton">Browse</Link>

          { validUserCreds() == true ? 
            <>
              <Link to="/profile/userDetails">Account</Link>
              <Link to="/applications" className="desktopMenuButton">My Applications</Link>
              <Link className='next' style={{ borderRadius: "5px", padding: "5px 20px", fontWeight: "bold", textAlign: "center"}} to="/trackApplication/">Track New Application</Link>
              <button className="warning" style={{padding: "5px 20px", bottom: "10px"}} onClick={() => {setMenuVis(false); signOut()}}>Log Out</button> 
            </>
            : 
            !curPath.toLowerCase().startsWith( "/login") ? 
            <button className="next" style={{padding: "5px 20px", bottom: "10px"}} onClick={() => { navigate("/login")}}>Log In</button>
            :
            undefined 
          }
        </nav>


        
        <nav className="mobile">
          <Link className={curPath.includes("home") || curPath == "/" ? "curPage menuButtons" : "menuButtons"} to="/home">
          <svg className="icon menuIcon" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48">
            <path d="M 10.994141 4.9921875 A 1.0001 1.0001 0 0 0 10.441406 6.8300781 C 10.441406 6.8300781 10.958728 7.1672724 11.802734 7.4492188 C 12.646741 7.7311651 13.882868 8 15.5 8 C 17.117132 8 18.353259 7.7311651 19.197266 7.4492188 C 20.041272 7.1672724 20.558594 6.8300781 20.558594 6.8300781 A 1.0005283 1.0005283 0 0 0 19.441406 5.1699219 C 19.441406 5.1699219 19.215244 5.3327276 18.5625 5.5507812 C 17.909756 5.7688349 16.895868 6 15.5 6 C 14.104132 6 13.090244 5.7688349 12.4375 5.5507812 C 11.784756 5.3327276 11.558594 5.1699219 11.558594 5.1699219 A 1.0001 1.0001 0 0 0 10.994141 4.9921875 z M 27.994141 4.9921875 A 1.0001 1.0001 0 0 0 27.441406 6.8300781 C 27.441406 6.8300781 27.958728 7.1672724 28.802734 7.4492188 C 29.646741 7.7311651 30.882868 8 32.5 8 C 34.117132 8 35.353259 7.7311651 36.197266 7.4492188 C 37.041272 7.1672724 37.558594 6.8300781 37.558594 6.8300781 A 1.0005283 1.0005283 0 0 0 36.441406 5.1699219 C 36.441406 5.1699219 36.215244 5.3327276 35.5625 5.5507812 C 34.909756 5.7688349 33.895868 6 32.5 6 C 31.104132 6 30.090244 5.7688349 29.4375 5.5507812 C 28.784756 5.3327276 28.558594 5.1699219 28.558594 5.1699219 A 1.0001 1.0001 0 0 0 27.994141 4.9921875 z M 11.984375 8.9863281 A 1.0001 1.0001 0 0 0 11 10 L 11 15 C 11 15.56503 10.56503 16 10 16 C 7.2504839 16 5 18.250484 5 21 L 5 40 C 5 41.64497 6.3550302 43 8 43 L 17 43 C 18.64497 43 20 41.64497 20 40 L 20 37.167969 A 1.0001 1.0001 0 0 0 20 36.841797 L 20 29 L 28 29 L 28 40 C 28 41.64497 29.35503 43 31 43 L 40 43 C 41.64497 43 43 41.64497 43 40 L 43 37.167969 A 1.0001 1.0001 0 0 0 43 36.841797 L 43 21 C 43 18.250484 40.749516 16 38 16 C 37.43497 16 37 15.56503 37 15 L 37 10 A 1.0001 1.0001 0 1 0 35 10 L 35 15 C 35 16.64497 36.35503 18 38 18 C 39.668484 18 41 19.331516 41 21 L 41 36 L 34 36 A 1.0001 1.0001 0 1 0 34 38 L 41 38 L 41 40 C 41 40.56503 40.56503 41 40 41 L 31 41 C 30.43497 41 30 40.56503 30 40 L 30 10 A 1.0001 1.0001 0 0 0 28.984375 8.9863281 A 1.0001 1.0001 0 0 0 28 10 L 28 19 L 20 19 L 20 10 A 1.0001 1.0001 0 1 0 18 10 L 18 36 L 10 36 A 1.0001 1.0001 0 1 0 10 38 L 18 38 L 18 40 C 18 40.56503 17.56503 41 17 41 L 8 41 C 7.4349698 41 7 40.56503 7 40 L 7 21 C 7 19.331516 8.3315161 18 10 18 C 11.64497 18 13 16.64497 13 15 L 13 10 A 1.0001 1.0001 0 0 0 11.984375 8.9863281 z M 20 21 L 28 21 L 28 27 L 20 27 L 20 21 z"/>
          </svg>
          Browse
          </Link>
          { userInfo.jwt_expiration !== undefined && parseInt(userInfo.jwt_expiration) > 0 ?
            <>
              <Link className={curPath.includes("trackApplication") ? "curPage menuButtons" : "menuButtons"} to="/trackApplication">
              <svg className="icon menuIcon" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48" >
                <path d="M 24 3 C 12.413858 3 3 12.413866 3 24 C 3 35.586134 12.413858 45 24 45 C 35.586142 45 45 35.586134 45 24 C 45 12.413866 35.586142 3 24 3 z M 24 5 C 34.505263 5 43 13.494744 43 24 C 43 34.505256 34.505263 43 24 43 C 13.494737 43 5 34.505256 5 24 C 5 13.494744 13.494737 5 24 5 z M 22 12 C 20.906937 12 20 12.906937 20 14 L 20 20 L 14 20 C 12.906937 20 12 20.906937 12 22 L 12 26 C 12 27.093063 12.906937 28 14 28 L 20 28 L 20 34 C 20 35.093063 20.906937 36 22 36 L 26 36 C 27.093063 36 28 35.093063 28 34 L 28 28 L 34 28 C 35.093063 28 36 27.093063 36 26 L 36 22 C 36 20.906937 35.093063 20 34 20 L 28 20 L 28 14 C 28 12.906937 27.093063 12 26 12 L 22 12 z M 22 14 L 26 14 L 26 21 A 1.0001 1.0001 0 0 0 27 22 L 34 22 L 34 26 L 27 26 A 1.0001 1.0001 0 0 0 26 27 L 26 34 L 22 34 L 22 27 A 1.0001 1.0001 0 0 0 21 26 L 14 26 L 14 22 L 21 22 A 1.0001 1.0001 0 0 0 22 21 L 22 14 z"/>
              </svg>
              Track
              </Link>
              <button className={curPath.includes("profile") ? "curPage menuButtons" : "menuButtons"} onClick={() => {setMenuVis(true)}}>
                <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50">
                  <path d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"/>
                </svg>
                Menu
              </button>
            </>
            :
            <>
              <Link 
                className="menuButtons next" 
                to="/login"
                style={{
                  height: "20px",
                  padding: "5px 10px",
                  borderRadius: "5px"
                }}
              >Log In</Link>
            </> 
          }
        </nav>

        { menuVis == true ? 
        <nav className="mobileScreen"
          style={{
            position: "absolute",
            right: "0px",
            top: "0px",
            height: "calc(100% - 20px)",
            minWidth: "100px",
            zIndex: "3",
            display: "flex",
            alignItems: "flex-end",
            gap: "5px",
            flexDirection: "column",
            padding: "10px",
            backgroundColor: "white",
            boxShadow: "2px 2px 10px grey"
          }}
        >
          <button style={{backgroundColor: "transparent", width: "fit-content", }} onClick={() => {setMenuVis(false)}}>x</button>
          { validUserCreds() == true ?
            <>
              <div style={{width: "100%", display: "grid", gridTemplateColumns: "8fr minmax(0, max-content) 1fr", gridTemplateRows: "auto", gridTemplateAreas: `"leftHR text rightHR"`, gap: "5px"}}>
                <hr style={{gridArea: "leftHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
                <Link style={curPath == "/" || curPath == "/home" || curPath == "" || /^\/\d\/\d{1,}$/.test(curPath) ? {color: "#10694D", fontWeight: "bold"} : { fontWeight: "bold"} } to="/" onClick={() => {setMenuVis(false)}}>General</Link>
                <hr style={{gridArea: "rightHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
              </div>
              <Link style={curPath == "/" || curPath == "/home" || curPath == "" || /^\/\d\/\d{1,}$/.test(curPath) ? {color: "#10694D"} : undefined } to="/" onClick={() => {setMenuVis(false)}}>Browse Listings</Link>
              <Link style={curPath == "/suggested" ? {color: "#10694D"} : undefined } to="/suggested" onClick={() => {setMenuVis(false)}}>View Suggested Jobs</Link>
              <Link style={curPath.startsWith("/trackApplication") ? {color: "#10694D"} : undefined } to="/trackApplication/" onClick={() => {setMenuVis(false)}}>Track New Applications</Link>
              <div style={{marginTop: "10px", width: "100%", display: "grid", gridTemplateColumns: "8fr minmax(0, max-content) 1fr", gridTemplateRows: "auto", gridTemplateAreas: `"leftHR text rightHR"`, gap: "5px"}}>
                <hr style={{gridArea: "leftHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
                <Link style={curPath.startsWith("/profile/userDetails") ? {color: "#10694D", fontWeight: "bold"} : { fontWeight: "bold"} } to="/profile/userDetails" onClick={() => {setMenuVis(false)}}>Account Info</Link>
                <hr style={{gridArea: "rightHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
              </div>
              <Link style={curPath.startsWith("/profile/userDetails") ? {color: "#10694D"} : undefined } to="/profile/userDetails" onClick={() => {setMenuVis(false)}}>User Details</Link>
              <Link style={curPath.startsWith("/profile/workExperience") ? {color: "#10694D"} : undefined} to="/profile/workExperience" onClick={() => {setMenuVis(false)}}>Work Experience</Link>
              <Link style={curPath.startsWith("/profile/skills") ? {color: "#10694D"} : undefined} to="/profile/skills" onClick={() => {setMenuVis(false)}}>Skills</Link>
              <Link style={curPath.startsWith("/profile/education") ? {color: "#10694D"} : undefined} to="/profile/education" onClick={() => {setMenuVis(false)}}>Education</Link>
              <Link style={curPath.startsWith("/profile/topicExcludes") ? {color: "#10694D"} : undefined} to="/profile/topicExcludes" onClick={() => {setMenuVis(false)}}>Topic Excludes</Link>
              <Link style={curPath.startsWith("/profile/desiredRoles") ? {color: "#10694D"} : undefined} to="/profile/desiredRoles" onClick={() => {setMenuVis(false)}}>Desired Roles</Link>
              <div style={{marginTop: "10px", width: "100%", display: "grid", gridTemplateColumns: "8fr minmax(0, max-content) 1fr", gridTemplateRows: "auto", gridTemplateAreas: `"leftHR text rightHR"`, gap: "5px"}}>
                <hr style={{gridArea: "leftHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
                <Link style={curPath.startsWith("/applications") ? {gridArea: "text", color: "#10694D", fontWeight: "bold"} : { fontWeight: "bold"}} to="/applications/all" onClick={() => {setMenuVis(false)}}>Applications</Link>
                <hr style={{gridArea: "rightHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
              </div>
              <Link style={curPath.startsWith("/applications/unapplied") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/unapplied" onClick={() => {setMenuVis(false)}}>Unapplied</Link>
              <Link style={curPath.startsWith("/applications/applied") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/applied" onClick={() => {setMenuVis(false)}}>Applied</Link>
              <Link style={curPath.startsWith("/applications/not_interested") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/not_interested" onClick={() => {setMenuVis(false)}}>Uninterested</Link>
              <Link style={curPath.startsWith("/applications/too_far") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/too_far" onClick={() => {setMenuVis(false)}}>Out of Range</Link>
              <Link style={curPath.startsWith("/applications/position_accepted") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/position_accepted" onClick={() => {setMenuVis(false)}}>Position Accepted</Link>
              <Link style={curPath.startsWith("/applications/interviewing") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/interviewing" onClick={() => {setMenuVis(false)}}>Interviewing</Link>
              <Link style={curPath.startsWith("/applications/not_selected") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/not_selected" onClick={() => {setMenuVis(false)}}>Not Selected</Link>
              <Link style={curPath.startsWith("/applications/does_not_exist") ? {color: "#10694D", fontSize: "14px"} : { fontSize: "14px"}} to="/applications/does_not_exist" onClick={() => {setMenuVis(false)}}>Does not Exist</Link>
              <div style={{marginTop: "10px", width: "100%", display: "grid", gridTemplateColumns: "8fr minmax(0, max-content) 1fr", gridTemplateRows: "auto", gridTemplateAreas: `"leftHR text rightHR"`, gap: "5px"}}>
                <hr style={{gridArea: "leftHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
                <span style={{ fontWeight: "bold"}}>Subscription</span>
                <hr style={{gridArea: "rightHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
              </div>
              <button
                style={{ fontWeight: "normal", backgroundColor: "transparent", padding: "0px", fontSize: "14px"}}
                onClick={() => {manageSubscription()}}
              >
                Manage
              </button>
              <div style={{marginTop: "10px", width: "100%", display: "grid", gridTemplateColumns: "8fr minmax(0, max-content) 1fr", gridTemplateRows: "auto", gridTemplateAreas: `"leftHR text rightHR"`, gap: "5px"}}>
                <hr style={{gridArea: "leftHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
                <a href="mailto:support@workguild.io" style={{ fontWeight: "bold"}}>Contact Us</a>
                <hr style={{gridArea: "rightHR", width: "100%", height: "0px", backgroundColor: "black", border: ".5px solid black"}}/>
              </div>
              <a href="mailto:support@workguild.io">Support</a>
              <button className="warning" type="button" style={{padding: "5px 20px", position: "absolute", bottom: "10px"}} onClick={() => {setMenuVis(false); signOut()}}>Log Out</button>
            </>
            :
            undefined
          }
        </nav>
        : undefined }
      </header>
    </>
  )
}

export default Header;